// src/components/store/sections/testimonials/TestimonialV56ArchportraitsRoyalViolet.tsx
"use client";

import React from "react";
import DynamicTestimonialVariant from "./DynamicTestimonialVariant";

export default function TestimonialV56ArchportraitsRoyalViolet(props: any) {
  return (
    <DynamicTestimonialVariant
      variantNumber={56}
      archKey="arch_portraits"
      archLabel="Cathedral Arch Portraits"
      palName="RoyalViolet"
      grad="from-violet-600 via-purple-600 to-indigo-700"
      lightBg="bg-violet-50"
      textCol="text-violet-700"
      borderCol="border-violet-200"
      btnCls="bg-violet-600 hover:bg-violet-700"
      hexCol="#8b5cf6"
      {...props}
    />
  );
}
